module.exports = __webpack_public_path__ + "img/home_icon.55e88378.svg";